import moment from 'jalali-moment';

// Picker values are Moments, not ISO instants: preserve the selected calendar day.
export function pickerDay(value) {
    const day = typeof value === 'string' ? moment.from(value, 'en', 'YYYY-MM-DD') : moment(value);
    const result = day.isValid() ? day.locale('en').format('YYYY-MM-DD') : '';
    return typeof value === 'string' && result !== value ? '' : result;
}
export function pickerValue(isoDay) {
    return moment.from(isoDay, 'en', 'YYYY-MM-DD').locale('fa');
}
